import { render, staticRenderFns } from "./OrgOrders.vue?vue&type=template&id=6cbe9326&scoped=true"
import script from "./OrgOrders.vue?vue&type=script&lang=js"
export * from "./OrgOrders.vue?vue&type=script&lang=js"
import style0 from "./OrgOrders.vue?vue&type=style&index=0&id=6cbe9326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe9326",
  null
  
)

export default component.exports